import {
  FETCHING_SUBSCRIPTION_STATUS,
  FETCHING_SUBSCRIPTION_STATUS_SUCCESS,
  FETCHING_SUBSCRIPTION_STATUS_FAILED,
  FETCHING_SUBSCRIPTION_USAGE,
  FETCHING_SUBSCRIPTION_USAGE_SUCCESS,
  FETCHING_SUBSCRIPTION_USAGE_FAILED,
  INITIATING_SUBSCRIPTION,
  INITIATING_SUBSCRIPTION_SUCCESS,
  INITIATING_SUBSCRIPTION_FAILED,
  CANCELLING_SUBSCRIPTION,
  CANCELLING_SUBSCRIPTION_SUCCESS,
  CANCELLING_SUBSCRIPTION_FAILED,
  FETCHING_SUB_PAYMENTS,
  FETCHING_SUB_PAYMENTS_SUCCESS,
  FETCHING_SUB_PAYMENTS_FAILED,
  FETCHING_PLANS,
  FETCHING_PLANS_SUCCESS,
  FETCHING_PLANS_FAILED,
  LOGGING_OUT_SUCCESS,
} from '../../utils/types';

const initialState = {
  // { id, status, billingInterval, startDate, endDate, plan: {id, name, description} }
  // null once loaded = no active subscription (fresh user)
  status: null,
  statusLoading: false,
  statusLoaded: false,
  // [{ feature: 'FORMS'|'RESPONSES'|'STORAGE_MB', limit, used, remaining, unlimited }]
  usage: [],
  usageLoading: false,
  // GET /plans rows (DB-backed catalog with GHS convertedPrices)
  plans: [],
  plansLoading: false,
  initiating: false,
  cancelling: false,
  payments: [],
  paymentsMeta: undefined,
  paymentsLoading: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOGGING_OUT_SUCCESS:
      return {
        ...initialState,
      };
    case FETCHING_SUBSCRIPTION_STATUS:
      return {
        ...state,
        statusLoading: true,
      };
    case FETCHING_SUBSCRIPTION_STATUS_SUCCESS:
      return {
        ...state,
        status: action.data,
        statusLoading: false,
        statusLoaded: true,
      };
    case FETCHING_SUBSCRIPTION_STATUS_FAILED:
      return {
        ...state,
        statusLoading: false,
      };
    case FETCHING_SUBSCRIPTION_USAGE:
      return {
        ...state,
        usageLoading: true,
      };
    case FETCHING_SUBSCRIPTION_USAGE_SUCCESS:
      return {
        ...state,
        usage: (action.data && action.data.usage) || [],
        usageLoading: false,
      };
    case FETCHING_SUBSCRIPTION_USAGE_FAILED:
      return {
        ...state,
        usageLoading: false,
      };
    case INITIATING_SUBSCRIPTION:
      return {
        ...state,
        initiating: true,
      };
    case INITIATING_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        initiating: false,
      };
    case INITIATING_SUBSCRIPTION_FAILED:
      return {
        ...state,
        initiating: false,
      };
    case CANCELLING_SUBSCRIPTION:
      return {
        ...state,
        cancelling: true,
      };
    case CANCELLING_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        cancelling: false,
      };
    case CANCELLING_SUBSCRIPTION_FAILED:
      return {
        ...state,
        cancelling: false,
      };
    case FETCHING_PLANS:
      return {
        ...state,
        plansLoading: true,
      };
    case FETCHING_PLANS_SUCCESS:
      return {
        ...state,
        plans: action.data || [],
        plansLoading: false,
      };
    case FETCHING_PLANS_FAILED:
      return {
        ...state,
        plansLoading: false,
      };
    case FETCHING_SUB_PAYMENTS:
      return {
        ...state,
        paymentsLoading: true,
      };
    case FETCHING_SUB_PAYMENTS_SUCCESS:
      return {
        ...state,
        payments: action.data || [],
        paymentsMeta: action.meta,
        paymentsLoading: false,
      };
    case FETCHING_SUB_PAYMENTS_FAILED:
      return {
        ...state,
        paymentsLoading: false,
      };
    default:
      return state;
  }
};
